/* pdp-lightbox.js — LUPA no hover (desktop) + lightbox com navegação da galeria.
   - Desktop: hover na imagem principal = lupa (janela quadrada ~2x que segue o cursor
     sobre a própria imagem); click = lightbox.
   - Mobile: sem lupa; tap = lightbox; pinça = zoom nativo (viewport permite escala);
     swipe (1 dedo) navega entre as imagens.
   - Lightbox VERTICAL: tela cheia na superficie base, as N imagens EMPILHADAS em
     tamanho grande e o usuario rola. X (circulo, canto sup-dir) / clique na margem /
     ESC fecham; setas do teclado, pager e swipe ROLAM ate a vizinha (com wrap-around);
     contador segue a rolagem; foco preso, foco volta pro gatilho.
     Quem rola e o proprio overlay, NAO a pagina: o body segue travado (L114).
   Coexistência com o CARRINHO (drawer), SEM tocar sua lógica (só LEIO a classe dele):
   - ESC EM CAMADAS: o carrinho fica por cima; com ambos abertos, 1º ESC fecha o
     carrinho e 2º ESC o lightbox (capturo e leio o estado ANTES de qualquer um fechar,
     então nunca fecho os dois de uma vez).
   - scroll-lock compartilhado: só libera quando AMBOS fecham (no close olho o carrinho;
     um MutationObserver reafirma o lock se o carrinho fechar por cima do lightbox).
   Perf: a resolução grande só carrega quando o lightbox abre / no 1º hover da lupa.
   Movimento reduzido: sem lupa e sem transições.
   NÃO toca a zona sensível (cortina/dive: transitions.js/theme.js/cart.js). */
(function () {
  'use strict';

  // ---- núcleo puro (testável) ----
  // índice com wrap-around
  function nextIndex(cur, len) { return len > 0 ? (cur + 1) % len : 0; }
  function prevIndex(cur, len) { return len > 0 ? (cur - 1 + len) % len : 0; }

  // LUPA — dois clamps distintos (calc puro):
  // clampBox: canto sup-esq da CAIXA da lupa, preso ao quadrado da imagem [0 .. size-lens]
  //   -> a caixa encosta na borda mas nunca vaza pro fundo.
  function clampBox(cursor, size, lens) {
    return Math.max(0, Math.min(cursor - lens / 2, size - lens));
  }
  // clampView: origem da JANELA dentro da imagem AMPLIADA [0 .. size*z - lens]
  //   -> alcança a borda REAL da foto (cantos), sem travar antes e sem faixa vazia.
  function clampView(cursor, size, lens, z) {
    return Math.max(0, Math.min(cursor * z - lens / 2, size * z - lens));
  }

  var api = { nextIndex: nextIndex, prevIndex: prevIndex, clampBox: clampBox, clampView: clampView };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined') { window.SXEPdpLightbox = api; }

  // ---- cola de DOM (browser apenas) ----
  if (typeof document === 'undefined') return;

  function init() {
    var section = document.querySelector('.pdp');
    if (!section) return;
    var mainWrap = section.querySelector('.pdp__main');
    var mainImg = section.querySelector('[data-main-img]');
    var box = section.querySelector('[data-lightbox]');
    if (!mainWrap || !mainImg || !box) return;

    var images = [];
    try { images = JSON.parse(section.querySelector('[data-lightbox-images]').textContent); } catch (e) {}
    if (!images.length) return;

    /* AS IMAGENS ESCRITAS DENTRO DA DESCRIÇÃO ENTRAM NA PILHA.
       Elas vêm do editor de texto rico do admin — o dono escreve texto, insere
       foto, escreve texto, insere foto. Chegam como <img> cru: sem classe, sem
       data-atributo, sem passar pelo Liquid da section. Então o JSON do servidor
       não sabe delas, e é aqui que a conta se fecha.

       A ORDEM IMPORTA e ela é: fotos do produto, depois as dos blocos (o Liquid
       já anexou), depois estas. Cada uma recebe o índice que acabou de ocupar,
       então o data-lightbox-open continua apontando certo para todas as três
       origens — e o listener delegado que já existe cuida do clique sem saber de
       onde a imagem veio.

       w/h ficam de fora de propósito: com loading lazy o naturalWidth pode ser 0
       antes de carregar, e paint() só aplica a medida `if (im.w)`. Mandar zero
       seria pior que não mandar.

       tabindex + role porque <img> não é focável nem anunciável como ação. Quem
       escreve no editor não tem como marcar isso, então quem marca somos nós. */
    var descImgs = [].slice.call(section.querySelectorAll('.pdp__desc img'));
    for (var d = 0; d < descImgs.length; d++) {
      var di = descImgs[d];
      images.push({
        src: di.getAttribute('src') || di.currentSrc || '',
        srcset: di.getAttribute('srcset') || '',
        alt: di.getAttribute('alt') || ''
      });
      di.setAttribute('data-lightbox-open', images.length - 1);
      di.setAttribute('tabindex', '0');
      di.setAttribute('role', 'button');
    }

    var stage = box.querySelector('[data-lightbox-scroll]');
    var imgEl = box.querySelector('[data-lightbox-img]');
    var counter = box.querySelector('[data-lightbox-counter]');
    var btnClose = box.querySelector('[data-lightbox-close]');
    var btnPrev = box.querySelector('[data-lightbox-prev]');
    var btnNext = box.querySelector('[data-lightbox-next]');
    var thumbs = [].slice.call(section.querySelectorAll('[data-thumb]'));
    var single = images.length < 2;
    var cur = 0;
    var lastFocus = null;
    // leitura (só leitura) do carrinho, pra ESC em camadas e scroll-lock compartilhado
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    function cartOpen() { return !!(cartDrawer && cartDrawer.classList.contains('is-open')); }

    if (single) {
      if (btnPrev) btnPrev.hidden = true;
      if (btnNext) btnNext.hidden = true;
      if (counter) counter.hidden = true;
    }

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    function motionOff() {
      return reduce || document.documentElement.getAttribute('data-motion') === 'off';
    }
    var canHover = false;
    try { canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}

    // índice inicial = thumb ativa (fallback 0), pra abrir na imagem que o usuário vê
    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    // ---- PILHA VERTICAL ----
    // O modelo antigo era UMA <img> trocando de src. Agora as N imagens coexistem
    // empilhadas e quem navega e a ROLAGEM. O <img> do Liquid vira o slot 0 e serve
    // de molde para os outros — construidos so no primeiro open(), o que mantem a
    // promessa de perf do modelo antigo (a resolucao grande nao entra no load da
    // PDP). loading="lazy" nao resolveria: dentro de display:none o comportamento
    // e indefinido entre browsers.
    var slides = [];
    function paint(el, i) {
      var im = images[i];
      el.setAttribute('src', im.src);
      if (im.srcset) el.setAttribute('srcset', im.srcset); else el.removeAttribute('srcset');
      if (im.w) el.setAttribute('width', im.w);
      if (im.h) el.setAttribute('height', im.h);
      el.setAttribute('alt', im.alt || '');
    }
    function label() {
      if (counter && !single) counter.textContent = (cur + 1) + ' / ' + images.length;
    }
    function build() {
      if (slides.length) return;
      var tpl = imgEl.cloneNode(false);   // molde limpo: clonado ANTES de qualquer src
      for (var i = 0; i < images.length; i++) {
        var el = i === 0 ? imgEl : tpl.cloneNode(false);
        if (i > 0) stage.appendChild(el);
        paint(el, i);
        slides.push(el);
      }
      spy();
    }
    // cur passa a SEGUIR a rolagem. Raiz colapsada numa faixa fina no meio do stage
    // (rootMargin -50%/-50%) em vez de threshold: com foto mais alta que a tela o
    // threshold nunca chegaria a 0.5 e o contador congelaria. Sem listener de
    // scroll — o tema usa Lenis e nao quer um segundo dono do evento.
    function spy() {
      if (!('IntersectionObserver' in window)) return; // sem IO: contador fica no indice de abertura; a pilha rola igual
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var k = slides.indexOf(entries[i].target);
          if (k >= 0) { cur = k; label(); }
        }
      }, { root: stage, rootMargin: '-50% 0px -50% 0px', threshold: 0 });
      for (var j = 0; j < slides.length; j++) io.observe(slides[j]);
    }
    // CONSUMIDOR NOVO de nextIndex/prevIndex: em vez de trocar o src, ROLA ate a
    // imagem vizinha. Setas do teclado, pager e swipe entram todos por aqui, entao
    // as duas funcoes puras (e os 4 testes delas) seguem exercitando codigo vivo —
    // e entregam o que a rolagem sozinha NAO da: wrap-around, do fim pro comeco.
    // Movimento reduzido: salto instantaneo. Rolagem suave e deslocamento.
    function goTo(i) {
      var el = slides[i];
      if (!el) return;
      cur = i;
      label();
      el.scrollIntoView({ block: 'start', behavior: motionOff() ? 'auto' : 'smooth' });
    }
    function goNext() { goTo(nextIndex(cur, images.length)); }
    function goPrev() { goTo(prevIndex(cur, images.length)); }
    function isOpen() { return box.classList.contains('is-open'); }

    function open(startIndex) {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      mainWrap.classList.remove('is-magnifying'); // fecha a lupa ao abrir o lightbox
      build();
      cur = typeof startIndex === 'number' ? startIndex : activeIndex();
      label();
      box.hidden = false;
      void box.offsetHeight; // reflow p/ a transição de opacidade
      box.classList.add('is-open');
      window.SXE.scrollLock.acquire('lightbox');
      // salto INSTANTANEO, nunca suave: o open ja e a transicao de opacidade —
      // rolar por cima dela faria a pilha escorregar enquanto aparece.
      if (slides[cur]) slides[cur].scrollIntoView({ block: 'start', behavior: 'auto' });
      // foco no SCROLLER, nao no X: e ele que rola no teclado (setas verticais,
      // PageDown, espaco). Com o foco no botao, espaco ACIONAVA o X em vez de rolar.
      (stage || box).focus({ preventScroll: true });
    }
    function close() {
      if (!isOpen()) return;
      mainWrap.classList.remove('is-magnifying'); // higiene: garante a lupa apagada ao fechar (simetria com open)
      box.classList.remove('is-open');
      // solta a MINHA trava e pronto. A pergunta `cartOpen() ? 'hidden' : ''` que
      // morava aqui virou a contagem do scroll-lock.js: se o carrinho ainda
      // estiver aberto, a entrada dele segura a pagina sem eu precisar saber.
      window.SXE.scrollLock.release('lightbox');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      if (motionOff()) { box.hidden = true; }
      else { setTimeout(function () { if (!isOpen()) box.hidden = true; }, 260); }
    }

    // gatilho: imagem principal (click + teclado, já que .pdp__main é role=button)
    mainWrap.addEventListener('click', function () { open(activeIndex()); });

    /* GATILHO DAS IMAGENS DA COLUNA. Os blocos de imagem da descrição são
       <button data-lightbox-open="N">, onde N é a posição daquela foto na pilha —
       product.images vem primeiro, as dos blocos vêm anexadas depois (ver o JSON
       em main-product.liquid). Abrir no índice certo é o que faz o clique parecer
       "abriu ESTA foto" em vez de "abriu a galeria".

       Delegado no `section` e não amarrado em cada botão: os blocos são
       reordenáveis no Customizer e o editor reinjeta o markup ao arrastar. Um
       listener por botão morreria nesse re-render; um só no ancestral sobrevive.

       Sem lupa aqui por decisão do dono: ela fica na foto da esquerda, que é a de
       inspeção. Nestas o gesto é clicar e ver grande. */
    function abrirPeloAlvo(el) {
      var i = parseInt(el.getAttribute('data-lightbox-open'), 10);
      open(isNaN(i) ? 0 : i);
    }
    section.addEventListener('click', function (e) {
      var alvo = e.target.closest && e.target.closest('[data-lightbox-open]');
      if (alvo) abrirPeloAlvo(alvo);
    });
    /* As imagens da descrição são <img> com role=button e tabindex, não <button>
       de verdade — elas vêm do editor de texto e não dá para pedir markup a quem
       escreve lá. Então o teclado precisa ser ligado à mão: sem isto elas ficam
       focáveis e mudas, que é pior que não serem focáveis.
       Espaço tem preventDefault porque senão a página rola atrás do lightbox que
       está abrindo. Os blocos, que já são <button>, não passam por aqui — o
       navegador dispara click neles sozinho. */
    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var alvo = e.target.closest && e.target.closest('[data-lightbox-open]');
      if (!alvo || alvo.tagName === 'BUTTON') return;
      e.preventDefault();
      abrirPeloAlvo(alvo);
    });
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); open(activeIndex()); }
    });

    if (btnClose) btnClose.addEventListener('click', close);
    if (btnNext) btnNext.addEventListener('click', goNext);
    if (btnPrev) btnPrev.addEventListener('click', goPrev);
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('pdp-lightbox__stage')) close();
    });

    // O SCROLLER entra na lista de focaveis: ele e tabindex=0, vem PRIMEIRO no DOM
    // (por isso ficou na frente dos botoes no Liquid) e e nele que o open() poe o
    // foco. Sem entrar aqui, Shift+Tab a partir dele vazaria pra pagina atras — a
    // armadilha so fecha o ciclo se o elemento focado inicialmente for o `first`.
    function focusables() {
      return [].slice.call(box.querySelectorAll('[data-lightbox-scroll], button:not([hidden]):not([disabled])')).filter(function (el) {
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
    }
    function trap(e) {
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // ESC EM CAMADAS: o carrinho fica POR CIMA do lightbox. Em CAPTURA (roda antes do
    // handler bubble do carrinho) eu leio o estado ANTES de qualquer um fechar: se o
    // carrinho está aberto, NÃO interfiro — deixo o ESC seguir e o carrinho fecha primeiro.
    // Só quando o lightbox é o topo da pilha (carrinho fechado) é que trato aqui.
    // (Capturar + ler antes evita que 1 ESC feche os dois de uma vez.)
    document.addEventListener('keydown', function (e) {
      if (!isOpen() || cartOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight' && !single) { e.preventDefault(); goNext(); }
      else if (e.key === 'ArrowLeft' && !single) { e.preventDefault(); goPrev(); }
      else if (e.key === 'Tab') { trap(e); }
    }, true);

    // swipe mobile (1 dedo); a pinça (2 dedos) fica pro browser (touch-action: pinch-zoom)
    var sx = 0, sy = 0, tracking = false;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (!tracking || single) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) goNext(); else goPrev();
      }
    }, { passive: true });

    // LUPA (magnifier) — só desktop (hover/ponteiro fino): janela quadrada sobre a
    // imagem que segue o cursor, mostrando ~2x aquela região. Substitui o zoom-follow.
    if (canHover) {
      var lens = mainWrap.querySelector('[data-lens]');
      var lensImg = lens ? lens.querySelector('[data-lens-img]') : null;
      var Z = 2;              // zoom moderado (~2x), sem exagero
      var lensSrcKey = '';

      function bumpWidth(url, w) {
        if (!url) return url;
        if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
      }
      // fonte da lupa = imagem principal ATUAL em resolução maior; carrega no 1º hover
      // (nada de full-res no load; segue thumb/variante porque lê o currentSrc vigente)
      function syncLensSrc() {
        if (!lensImg) return;
        var want = bumpWidth(mainImg.currentSrc || mainImg.src, 1600);
        if (want && want !== lensSrcKey) { lensSrcKey = want; lensImg.src = want; }
      }
      function moveLens(e) {
        if (!lens || !lensImg) return;
        var r = mainWrap.getBoundingClientRect();
        var L = lens.clientWidth || 170; // viewport de conteúdo da lupa (sem a borda), p/ alcançar a borda real
        var W = r.width, H = r.height;
        // imagem da lupa = container * Z (mesmo crop cover, Z vezes maior)
        lensImg.style.width = (W * Z) + 'px';
        lensImg.style.height = (H * Z) + 'px';
        // cursor dentro do quadrado da imagem
        var px = Math.max(0, Math.min(e.clientX - r.left, W));
        var py = Math.max(0, Math.min(e.clientY - r.top, H));
        // Clamp 1 — CAIXA: nunca vaza pra fora da imagem
        lens.style.left = clampBox(px, W, L) + 'px';
        lens.style.top = clampBox(py, H, L) + 'px';
        // Clamp 2 — JANELA na imagem ampliada: alcança a borda real, sem faixa vazia
        lensImg.style.left = (-clampView(px, W, L, Z)) + 'px';
        lensImg.style.top = (-clampView(py, H, L, Z)) + 'px';
      }
      // A lupa acende no MOVIMENTO real, não no mouseenter: um enter-fantasma de ponteiro
      // parado — o que o browser dispara quando o overlay do lightbox some sob o cursor ao
      // fechar — não tem mousemove depois, então nunca acende a lente (sem órfã). Hover normal
      // no desktop sempre gera mousemove, então acende igual (só 1 evento de latência a mais).
      mainWrap.addEventListener('mouseenter', function () {
        if (motionOff() || isOpen() || !lensImg) return; // reduced-motion: sem lupa; nem sob o lightbox
        syncLensSrc();                                    // pré-carrega a fonte no 1º hover; NÃO acende (sem tracking)
      });
      mainWrap.addEventListener('mousemove', function (e) {
        if (motionOff() || isOpen() || !lensImg) return;  // não acende sob lightbox / reduced-motion
        mainWrap.classList.add('is-magnifying');           // acende só com movimento real do cursor
        moveLens(e);
      });
      mainWrap.addEventListener('mouseleave', function () {
        mainWrap.classList.remove('is-magnifying');
      });
    }

    // ESC em camadas: se o CARRINHO fechar por cima (ESC/X/overlay) enquanto o
    // lightbox segue aberto, o foco tem que voltar pra cá — o lightbox voltou a ser
    // o topo da pilha. Só observo a classe do carrinho, não toco na lógica dele.
    //
    // A REAFIRMAÇÃO DA TRAVA SAIU DAQUI, e ela era a razão original deste observer:
    // o closeDrawer do carrinho zerava body.overflow sem perguntar por ninguém, e
    // esta linha reescrevia 'hidden' depois. Com a contagem do scroll-lock.js o
    // carrinho solta só a entrada dele e a minha continua segurando a página, então
    // não há mais o que reafirmar. O que sobra é a devolução de foco, que sempre foi
    // comportamento próprio e não remendo.
    if (cartDrawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!isOpen()) return;
        if (!cartOpen() && !box.contains(document.activeElement)) {
          (btnClose || box).focus({ preventScroll: true });
        }
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    // navegação (cortina/View Transitions): fecha e limpa, sem estado preso
    window.addEventListener('pagehide', function () {
      mainWrap.classList.remove('is-magnifying');
      if (!isOpen()) return;
      box.classList.remove('is-open');
      box.hidden = true;
      window.SXE.scrollLock.release('lightbox');
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
